var storage = {
    set(key, value) {
        if (!key) {
            return
        }
        if (!value) {
            this.remove(key);
        }

        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        if (localStorage.getItem(key)) {
            return JSON.parse(localStorage.getItem(key));
        } else {
            return null;
        }


    },
    remove(key) {
        localStorage.removeItem(key)
    },
    // 判断浏览器是否支持 hasLocalSotrage
    hasLocalSotrage: function () {
        return window.Storage && window.localStorage && window.localStorage instanceof Storage
    },
    //设置cookie
    setCookie: function (key, value, day) {
        var t = day || 30;
        var d = new Date();
        d.setTime(d.getTime() + (t * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = key + "=" + value + "; " + expires;
    },
    //获取cookie
    getCookie: function (name) {
        var arr, reg = new RegExp("(^|)" + name + "=([^]*)(|$)");
        if (arr = document.cookie.match(reg)) {
            return arr[2];
        }
        else {
            return null;
        }
    }
}


// function isJSON(str) {
//     if (typeof str == 'string') {
//         try {
//             var obj = JSON.parse(str);
//             if (typeof obj == 'object' && obj) {
//                 return true;
//             } else {
//                 return false;
//             }

//         } catch (e) {
//             console.log('error：' + str + '!!!' + e);
//             return false;
//         }
//     }
//     console.log('It is not a string!')
// }

export default storage;